import { render, staticRenderFns } from "./OccDisSur.vue?vue&type=template&id=05663a13&scoped=true&"
import script from "./OccDisSur.vue?vue&type=script&lang=js&"
export * from "./OccDisSur.vue?vue&type=script&lang=js&"
import style0 from "./OccDisSur.vue?vue&type=style&index=0&id=05663a13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05663a13",
  null
  
)

export default component.exports